import axios from 'axios';

const BASE_URL = 'https://eventbooking.apanel.leewaysofttech.com/BOOK_YOUR_SHOW_API';

const api = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

export const fetchEvents = async () => {
    try {
        const response = await api.get('/get_events.php');
        if (response.data.success === 1) {
            return response.data.events;
        }
        return [];
    } catch (error) {
        console.error("Error fetching events:", error);
        throw error;
    }
};

export const login = async (email, password) => {
    try {
        const response = await api.post('/login.php', { email, password });
        return response.data;
    } catch (error) {
        console.error("Login error:", error);
        throw error;
    }
};

export const register = async (userData) => {
    try {
        const response = await api.post('/register.php', userData);
        return response.data;
    } catch (error) {
        console.error("Registration error:", error);
        throw error;
    }
};

export const fetchBookedSeats = async (eventId) => {
    try {
        const response = await api.get(`/book_seat.php?event_id=${eventId}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching booked seats:", error);
        throw error;
    }
};

export default api;
